import type { ReactNode } from "react"

import { cx } from "@/components/ui/cx"
import { Link, type LinkProps } from "@/components/ui/link"
import { adminSchoolPath } from "@/routes"
import type { SchoolReference } from "@/types"

/*
 * A school, wherever a page names one: a print link to the school's card, the
 * console's one way of writing an account's name. The server hands the page a
 * SchoolReference (Account#reference); a page without one shows the fallback.
 * Inside a row-link cell it behaves like Table.Link: the link wins, not the row.
 */
export function SchoolLink({
  school,
  fallback = "—",
  className,
  ...props
}: Omit<LinkProps, "href" | "children"> & {
  school: SchoolReference | null | undefined
  fallback?: ReactNode
}) {
  if (!school) return <>{fallback}</>
  return (
    <Link
      href={adminSchoolPath(school.id)}
      className={cx(
        "decoration-1 underline-offset-[3px] hover:underline",
        typeof className === "string" ? className : undefined,
      )}
      {...props}
    >
      {school.name ?? fallback}
    </Link>
  )
}
